/**
 * 小売開栓結果登録API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 署名情報
 */
export interface Sgkb121aReqSignatureInfoDto {
    /** 
     * 署名区分：半角数字
     */
    signatureDiv?: string;
    /** 
     * 署名ファイルパス：半角英数混在
     */
    signatureFilePath?: string;
}
